
import React from "react";
import { Button } from "./button";
import { useImageUpload } from "@/hooks/useImageUpload";
import { ImagePreview } from "./image-preview";

interface ImageUploadProps {
  value: string | null | undefined;
  onChange: (url: string) => void;
  onRemove?: () => void;
  className?: string;
  disabled?: boolean;
  showRemove?: boolean;
  size?: "sm" | "md" | "lg";
}

const ImageUpload: React.FC<ImageUploadProps> = ({
  value,
  onChange,
  onRemove,
  className = "",
  disabled = false,
  showRemove = true,
  size = "md",
}) => {
  const { uploading, handleUpload, handleRemove } = useImageUpload({
    initialUrl: value || ""
  });

  const handleRemoveClick = () => {
    if (onRemove) {
      onRemove();
    } else {
      handleRemove();
      onChange("");
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      handleUpload(file)
        .then((url) => {
          if (url) {
            onChange(url);
          }
        });
    }
  };

  return (
    <div className={`flex flex-col items-center gap-3 ${className}`}>
      <ImagePreview
        value={value}
        onRemove={handleRemoveClick}
        size={size}
        showRemove={showRemove}
        disabled={disabled}
      />

      <div className="flex flex-col gap-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={uploading || disabled}
          className="relative"
          asChild
        >
          <label>
            {uploading ? "Uploading..." : "Upload Image"}
            <input
              type="file"
              className="sr-only"
              onChange={handleFileChange}
              disabled={uploading || disabled}
              accept="image/*"
            />
          </label>
        </Button>
      </div>
    </div>
  );
};

export { ImageUpload };
